// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sphere_wrapper__ho5AN","alt":"Sphere_alt__3fIw7","p-1":"Sphere_p-1__2hEYT","p-2":"Sphere_p-2__Ms9Z8","p-3":"Sphere_p-3__Gcg32","p-4":"Sphere_p-4__1DBs_"};